import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';
import { Session } from '../../shared/types/session';
import { UserSessionService } from '../../shared/services/user-session.service';
import { DestroyRxComponent } from '../destroy-rx/destroy-rx.component';

@Component({
    selector: 'las-session',
    templateUrl: './session.component.html',
    styleUrls: ['./session.component.scss'],
    standalone: false,
})
export class SessionComponent extends DestroyRxComponent implements OnInit {
    sessions!: Session[];

    constructor(
        private sessionService: SessionService,
        private session: UserSessionService,
    ) {
        super();
    }

    /**
     * Loads all sessions from the api.
     */
    ngOnInit() {
        // This should be handled in the app component now.
        // this.sessionService.initSession();
        this.sessionService.getSessions().subscribe((sessions) => {
            this.sessions = sessions;
        });
    }

    /**
     * Sets the current session which triggers reloads of cached data for in-scope components.
     * @param session The selected session.
     */
    onSessionClick(session: Session) {
        this.session.setSession(session);
    }
}
